// @flow
import { APICore } from './apiCore';
import config from '../../config';
const api = new APICore();

function ApiPostImage(params: any, id: any): any {
    const baseUrl = `${config.API_FTP}/upload`;
    return api.create(`${baseUrl}`, params);
}
function ApigetImage(url: any): any {
    const baseUrl = `${config.API_FTP_view}/get/${url}`;
    return api.get(`${baseUrl}`);
}

export { ApiPostImage, ApigetImage };
